"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformToNoteAttributes = exports.xhrPostToLittledata = void 0;
const convertPayloadToTm2ClientIdDTO = (payload) => {
    var _a;
    return {
        shopDomain: payload.shopDomain || ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname),
        clientID: {
            ...((payload["_fbp-clientID"] || payload["_fbc-clientID"]) && {
                facebook: {
                    fbp: payload["_fbp-clientID"],
                    fbc: payload["_fbc-clientID"],
                },
            }),
            ...(payload["_segment-clientID"] && {
                segment: {
                    anonymousId: payload["_segment-clientID"],
                },
            }),
            ...((payload["_ttp-clientID"] || payload["_ttclid-clientID"]) && {
                tiktok: {
                    ttp: payload["_ttp-clientID"],
                    ttclid: payload["_ttclid-clientID"],
                },
            }),
            ...(payload["_google-clientID"] && {
                googleAnalytics4: {
                    cid: payload["_google-clientID"],
                    ...(payload["_ga4session-clientID"] && {
                        sid: payload["_ga4session-clientID"],
                    }),
                },
            }),
        },
        ...(payload.cartID && { cartID: payload.cartID }),
        ...(payload.checkoutID && { checkoutID: payload.checkoutID }),
        ...(payload.userID && { userID: payload.userID }),
        ...(payload.ip && { ip: payload.ip }),
    };
};
/**
 * Sends data to Littledata server
 * @param {ILDTransactionMonitorPayload} payload ldPayload object containing
 * all the available IDs and one of the tokens
 * @returns {Promise<unknown>} sends ldPayload object to Littledata server
 */
const xhrPostToLittledata = async (payload) => {
    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.open("POST", "https://transaction-watcher-2.littledata.io/clientID/shopify", true);
        xhr.onreadystatechange = () => {
            if (xhr.readyState == XMLHttpRequest.DONE) {
                if (xhr.status >= 200 && xhr.status < 300) {
                    try {
                        resolve(JSON.parse(xhr.responseText).data);
                    }
                    catch (error) {
                        reject(error);
                    }
                }
                else if (xhr.status) {
                    try {
                        reject(JSON.parse(xhr.responseText).error);
                    }
                    catch (error) {
                        reject(error);
                    }
                }
                else {
                    reject(new Error("An error occurred whilst sending the request to Littledata server."));
                }
            }
        };
        xhr.setRequestHeader("Content-Type", "application/json");
        const body = JSON.stringify(convertPayloadToTm2ClientIdDTO(payload));
        xhr.send(body);
    });
};
exports.xhrPostToLittledata = xhrPostToLittledata;
// This is the object that should be used to update Note Attributes of the Checkout.
// Example is based on Shopify JS Buy SDK (https://www.npmjs.com/package/shopify-buy)
// and the method used is
// https://shopify.github.io/js-buy-sdk/#updating-checkout-attributes
// If you need a different output to match another Shopify API,
// please use this method's output object as an input for your own function.
/**
 * Transforms the payload into Shopify SDK Note Attributes object.
 * @param {ILDTransactionMonitorPayload} payload ldPayload object
 * @returns {Promise<IShopifyNoteAttribute>} Shopify Note Attributes object
 */
const transformToNoteAttributes = async (payload) => {
    return Object.keys(payload).map((key) => ({
        key,
        value: payload[key],
    }));
};
exports.transformToNoteAttributes = transformToNoteAttributes;
